import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 部屋種別変更ダイアログ
 */
class RoomTypeSelection extends Dialog {
    targetRoom: marietta.webcad.item.Room;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);

      // ダイアログのコンテンツ生成
      const id = 'roomTypeSelectionDialog';
      let title = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Select Room Type'; break;
        default: title = '部屋の種類を選択してください'; break;
      }
      let contents = '<div class="dialogRoomTypeBtns">\n';
      contents += '<button value="rom10_01" style="background-color:#F4F1EA"><span class="jp">洋室</span><span class="en">Bedroom</span></button>';
      contents += '<button value="rom14_01" style="background-color:#FEFBF1"><span class="jp">収納</span><span class="en">Storage</span></button>';
      contents += '<button value="rom18_01" style="background-color:#F4F1EA"><span class="jp">ﾊﾞﾙｺﾆｰ</span><span class="en">Balcony</span></button>';
      contents += '<button value="rom04_01" style="background-color:#FEFBF1"><span class="jp">L</span><span class="en">Living</span></button>';
      contents += '<button value="rom05_01" style="background-color:#FEFBF1"><span class="jp">D</span><span class="en">Dining</span></button>';
      contents += '<button value="rom06_01" style="background-color:#FEFBF1"><span class="jp">K</span><span class="en">Kitchen</span></button>';
      contents += '<button value="rom11_01" style="background-color:#FFFFFF"><span class="jp">和室</span><span class="en">Washitu</span></button>';
      contents += '<button value="rom12_01" style="background-color:#F4F1EA"><span class="jp">床の間</span><span class="en">Tokonoma</span></button>';
      contents += '<button value="rom13_01" style="background-color:#F4F1EA"><span class="jp">広縁</span><span class="en">Hiroen</span></button>';
      contents += '<button value="rom25_01" style="background-color:#FEFBF1"><span class="jp">LD</span><span class="en">LD</span></button>';
      contents += '<button value="rom26_01" style="background-color:#FEFBF1"><span class="jp">LDK</span><span class="en">LDK</span></button>';
      contents += '<button value="rom02_01" style="background-color:#F4F1EA"><span class="jp">廊下</span><span class="en">Hallway</span></button>';
      contents += '<button value="rom09_01" style="background-color:#F4FCFF"><span class="jp">浴室</span><span class="en">Bath</span></button>';
      contents += '<button value="rom08_01" style="background-color:#F4FCFF"><span class="jp">トイレ</span><span class="en">Toilet</span></button>';
      contents += '<button value="rom07_01" style="background-color:#F4FCFF"><span class="jp">洗面所</span><span class="en">Restroom</span></button>';
      contents += '<button value="rom03_01" style="background-color:#F3F3F3"><span class="jp">玄関</span><span class="en">Entrance</span></button>';
      contents += '<button value="rom01_01" style="background-color:#F3F3F3"><span class="jp">ポーチ</span><span class="en">Porch</span></button>';
      contents += '<button value="rom17_01" style="background-color:#FFFFFF"><span class="jp">吹抜け</span><span class="en">Stairwell</span></button>';
      contents += '<button value="rom27_01" style="background-color:#F3F3F3"><span class="jp">ガレージ</span><span class="en">Garage</span></button>';
      contents += '<button value="rom28_01" style="background-color:#F4F1EA"><span class="jp">土間</span><span class="en">Doma</span></button>';
      contents += '<button value="rom36_01" style="background-color:#F4F1EA"><span class="jp">PS</span><span class="en">PS</span></button>';
      contents += '<button value="rom37_01" style="background-color:#F4F1EA"><span class="jp">MB</span><span class="en">MB</span></button>';
      contents += '<button value="rom00_01" style="background-color:#F4F1EA"><span class="jp">土間</span><span class="en">blank</span></button>';
      contents += '</div>';

      const footer = '';

      this.createDialog(id, title, contents, footer);

      // イベント設定
      const btns = document.querySelectorAll('.dialogRoomTypeBtns button');
      for (let i = 0, len = btns.length; i < len; i += 1) {
        btns[i].addEventListener('click', this.onSelectType);
      }
    }

    /**
     * 種類ボタンが選択された
     */
    onSelectType = (e: MouseEvent) => {
      e.preventDefault();

      const type: string = <string>(<HTMLButtonElement>e.currentTarget).getAttribute('value');

      this.targetRoom.itemInfo.id = type;
      this.targetRoom.resetAllWallTypes();

      // itemInfoのコピー
      const itemInfo: marietta.webcad.collection.ItemInfoCollection = this.targetRoom.itemInfo.clone();
      itemInfo.id = type;

      // eslint-disable-next-line no-multi-assign
      const roomSettings = this.targetRoom._defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(type);
      itemInfo.text = roomSettings.text; // 部屋名称のデフォルト設定
      itemInfo.color = roomSettings.color; // デフォルトの塗りを適用する
      itemInfo.designColor = roomSettings.designColor; // デフォルトのテクスチャカラーを設定する
      itemInfo.design_type = roomSettings.design_type; // デフォルトのテクスチャを設定する
      itemInfo.text_visible = roomSettings.text_visible;
      itemInfo.text_area_visible = roomSettings.text_area_visible;
      itemInfo.area_use_jyou = roomSettings.area_use_jyou;

      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;
      // 削除
      this.targetRoom.deleteMe();

      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;
      // 新しいアイテムの生成
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemInfo);

      // ヒストリ
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

      // パネルを閉じる
      marietta.webcad.WebCADGlobal.removeDialog();
    }
}
export default RoomTypeSelection;
